import React, { useContext, useState } from 'react';
import { Button, Box, Popover, List, ListItem,IconButton,  Typography, useMediaQuery } from '@mui/material';
import { styled } from '@mui/system';
import SettingsIcon from '@mui/icons-material/Settings';
import PopoverCard from './PopoverCard';
import AccessoryCardPopover from './AccessoryCardPopover';
import { setAccessories as setExploreDareAccessories } from '../features/explore/exploreDare/exploreDareSlice';
import { setAccessories as setComfortDareAccessories } from '../features/comfort/comfortDare/comfortDareSlice';
import { setAccessories as setComfortLightDareAccessories } from '../features/comfort/comfortLightDare/comfortLightDareSlice';
import { setAccessories as setOpenDareAccessories } from '../features/open/openDare/openDareSlice';
import { setAccessories as setOpenLightDareAccessories } from '../features/open/openLightDare/openLightDareSlice';
import { setAccessories as setOpenKinkyDareAccessories } from '../features/open/openKinkyDare/openKinkyDareSlice';
import { useDispatch, useSelector } from 'react-redux';
import { setGameMode } from '../features/contestants/contestantsSlice';
import { recordGameModeSwitch } from '../features/gamesStatus/gameSessionApi';
import { logout } from '../lib/allauth'
import { AuthContext } from '../auth/AuthContext';
import { useNavigate } from 'react-router-dom';
import { isInStandaloneMode } from '../utils/deviceDetect';

const GearButton = styled(Button)({
  position: 'fixed',
  top: 'calc(env(safe-area-inset-top, 0px) + 16px)',
  right: 'calc(env(safe-area-inset-right, 0px) + 16px)',
  zIndex: 1000,
  width: '36px',
  height: '36px',
  borderRadius: '8px',
  backgroundColor: 'rgba(255, 191, 229, 0.05)',
  color: '#d48aae',
  boxShadow: '0 0 6px rgba(255, 191, 229, 0.1)',
  backdropFilter: 'blur(4px)',
  border: '1px solid rgba(255, 191, 229, 0.05)',
  transition: 'all 0.3s ease',
  '&:hover': {
    backgroundColor: 'rgba(255, 191, 229, 0.08)',
    boxShadow: '0 0 8px rgba(255, 191, 229, 0.15)',
  },
});


const PopoverButton = styled(Button)({
  margin: '6px 0',
  background: `
    radial-gradient(ellipse at 50% 0%, rgba(160, 55, 120, 0.18), transparent 65%),
    linear-gradient(to bottom, #2e0f20 0%, #1e0916 55%, #160710 100%)
  `,
  color: '#d48aae',
  fontFamily: 'Playfair Display, serif',
  fontWeight: 500,
  fontSize: '0.9rem',
  letterSpacing: '0.07em',
  textTransform: 'none',
  width: '100%',
  padding: '10px 20px',
  borderRadius: '50px',
  border: '1px solid rgba(160, 55, 110, 0.28)',
  boxShadow: '0 0 18px rgba(140, 40, 95, 0.18), 0 4px 14px rgba(0, 0, 0, 0.55)',
  transition: 'transform 0.2s ease, box-shadow 0.2s ease',

  '&:hover': {
    transform: 'scale(1.03)',
    boxShadow: '0 0 24px rgba(155, 50, 110, 0.28), 0 4px 16px rgba(0, 0, 0, 0.6)',
  },
});
const ThemedPopover = styled(Popover)({
  marginTop: '10px',
  '& .MuiPaper-root': {
    background: `
      radial-gradient(ellipse at 15% 15%, rgba(89, 18, 51, 0.25) 0%, transparent 55%),
      radial-gradient(ellipse at 85% 85%, rgba(64, 13, 41, 0.2) 0%, transparent 50%),
      #1c0a18
    `,
    borderRadius: '20px',
    padding: '20px 16px',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.55)',
    backdropFilter: 'blur(14px)',
    border: '1px solid rgba(89, 18, 51, 0.22)',
  },
});


const MenuButton = ({
  showLogin,
  showAccount,
  showRestart,
  showChangeAccessories,
  showQuitGame,
  showQuitApp,
  showSwitchGameMode,
  onRestartClick,
  onQuitGameClick,
  onSaveAndQuit,
  gameType,
  faq,
  showDownload,
  onSaveAndDownload,
  onDiscardAndDownload,
}) => {

  const navigate = useNavigate()
  const { auth } = useContext(AuthContext)
  const isMobile = useMediaQuery('(max-width: 768px)')
  const gameMode = useSelector((state) => state.contestants.gameMode);
  const blockModeSwitch = useSelector((state) => state.contestants.blockModeSwitch);
  const sessionId = useSelector((state) => state.gameStatus?.sessions?.[gameType]?.sessionId);
  const [anchorEl, setAnchorEl] = useState(null);
  const [quitGamePopover, setQuitGamePopover] = useState(false)
  const [accessoryPopoverOpen, setAccessoryPopoverOpen] = useState(false)
  const [restartPopover, setRestartPopover] = useState(false)
  const [logoutPopover, setLogoutPopover] = useState(false)
  const [quitAppPopover, setQuitAppPopover] = useState(false)
  const [switchGameModePopover, setSwitchGameModePopover] = useState(false)
  const [downloadPopover, setDownloadPopover] = useState(false)
  const [logoutResponse, setLogoutResponse] = useState({ fetching: false, content: null })
  const dispatch = useDispatch()
  
  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };
  
  const handleClose = () => {
    setAnchorEl(null);
    setQuitAppPopover(false);
    setQuitGamePopover(false);
    setRestartPopover(false);
    setLogoutPopover(false);
    setSwitchGameModePopover(false);
    setDownloadPopover(false);
  };
  const handleDownloadClick = () => {
    if (sessionId && onSaveAndDownload && onDiscardAndDownload) {
      setDownloadPopover(true);
    } else {
      navigate('/download');
    }
  };
  const handleRestart = () =>{
    setRestartPopover(false)
    handleClose()
    onRestartClick()
  }
  const handleQuit = () => {
    setQuitGamePopover(true)
  }
  const handleCloseQuitPopover = () => {
    setQuitGamePopover(false)
  }
  const handleLogin = () =>{
    navigate('/account/login')
  }
  const handleCloseLogout = () =>{
    setLogoutPopover(false)
  }
  const handleOpenLogout = () =>{
    setLogoutPopover(true)
  }
  const handleAccountSetting = () =>{
    navigate('/account/profile/')
    // setLoginPopoverOpen(true)
  }

  const handleSwitchGameMode = () => {
    setSwitchGameModePopover(true);
  };

  const handleConfirmSwitchGameMode = () => {
    const newMode = gameMode === 'drink' ? 'replay' : 'drink';
    dispatch(setGameMode(newMode));
    setSwitchGameModePopover(false);
    handleClose();
    if (sessionId) {
      recordGameModeSwitch({ sessionId, newGameMode: newMode });
    }
  };

  const handleAccessoryChange = (selectedAccessories) => {
    if (gameType === "explore") {
      dispatch(setExploreDareAccessories(selectedAccessories));
    } else if (gameType === "comfort") {
      dispatch(setComfortDareAccessories(selectedAccessories));
      dispatch(setComfortLightDareAccessories(selectedAccessories));
    } else {
      dispatch(setOpenDareAccessories(selectedAccessories));
      dispatch(setOpenLightDareAccessories(selectedAccessories));
      dispatch(setOpenKinkyDareAccessories(selectedAccessories));
    }
  };

  const handleLogout = () =>{
    setLogoutResponse({ ...logoutResponse, fetching: true })
    logout().then((content) => {
      setLogoutResponse((r) => { return { ...r, content } })
    }).catch((e) => {
      console.error(e)
      window.alert(e)
    }).then(() => {
      setLogoutResponse((r) => { return { ...r, fetching: false } })
    })
    setAnchorEl(null)
    navigate('/')
    handleCloseLogout()
  }

  
  const open = Boolean(anchorEl);
  const id = open ? 'settings-popover' : undefined;
  return (
    <>
        <GearButton onClick={handleClick}>
          <SettingsIcon />
        </GearButton>
        <ThemedPopover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          ><Box display="flex" flexDirection="column" alignItems="center" >
          {!auth || auth.meta.is_authenticated === false ? (
            showLogin && (
              <PopoverButton onClick={handleLogin}>Log-In/Signup</PopoverButton>
            )
          ) :( showAccount && (<>
          <PopoverButton onClick={handleAccountSetting}>{auth.data?.user?.email} profile</PopoverButton>
          <PopoverButton onClick={handleOpenLogout}>Logout</PopoverButton>
          </>))}
          {/* {auth.data?.user?. != "Super Premium" ? ():} */}
          {faq && <PopoverButton onClick={() => {navigate('/faq')}}>FAQ & Info</PopoverButton>}
          {showDownload && !isInStandaloneMode() && <PopoverButton onClick={handleDownloadClick}>Download</PopoverButton>}
          {showSwitchGameMode && !blockModeSwitch && (
            <PopoverButton onClick={handleSwitchGameMode}>
              Switch to {gameMode === 'drink' ? 'Replay Mode' : 'Drink Mode'}
            </PopoverButton>
          )}
          {showRestart && <PopoverButton onClick={() => setRestartPopover(true)}>Restart</PopoverButton>}
          {showChangeAccessories && <PopoverButton onClick={() => setAccessoryPopoverOpen(true)}>Change Accessories</PopoverButton>}
          {showQuitGame && <PopoverButton onClick={() =>  setQuitGamePopover(true)}>Quit Game</PopoverButton>}
          {showQuitApp && isMobile && <PopoverButton onClick={() => setQuitAppPopover(true)}>Quit App</PopoverButton>}
          <PopoverCard
            open={quitAppPopover}
            onClose={() => setQuitAppPopover(false)}
            mainText={'Are you sure you want to close the app?'}
            showButtonOne={true}
            textButtonOne={'Yes, Close'}
            onButtonOne={() => window.close()}
            />
          <PopoverCard
            id = 'quitgamepopver'
            open ={quitGamePopover}
            onClose ={() => setQuitGamePopover(false)}
            showButtonOne ={true}
            textButtonOne ={'Save Game And Quit '}
            onButtonOne ={onSaveAndQuit}
            showButtonTwo ={true}
            textButtonTwo ={'Quit Game'}
            onButtonTwo ={onQuitGameClick}

            />

          <PopoverCard
            id = 'downloadpopover'
            open ={downloadPopover}
            onClose ={() => setDownloadPopover(false)}
            mainText={'For the best experience, we recommend downloading the app! Want to save this game before heading to the download page?'}
            showButtonOne ={true}
            textButtonOne ={'Save Game & Continue'}
            onButtonOne ={onSaveAndDownload}
            showButtonTwo ={true}
            textButtonTwo ={'Continue Without Saving'}
            onButtonTwo ={onDiscardAndDownload}

            />

            <PopoverCard
            id = 'logoutpopover'
            open ={logoutPopover}
            onClose ={() => setLogoutPopover(false)}
            mainText={'Are You Sure You Want To Log Out? Any Game Currently In Progress Will Reset'}
            showButtonOne ={true}
            textButtonOne ={'Logout'}
            onButtonOne ={handleLogout}

            
            />
            <PopoverCard
            id = 'restartpopover'
            open ={restartPopover}
            onClose ={() => setRestartPopover(false)}
            mainText={'Are You Sure You Want To Restart The Game? Any progress in this game will be lost.'}
            showButtonOne ={true}
            textButtonOne ={'restart'}
            onButtonOne ={handleRestart}

            
            />
          <PopoverCard
            open={switchGameModePopover}
            onClose={() => setSwitchGameModePopover(false)}
            mainText={
              gameMode === 'drink'
                ? 'Switch to Replay Mode? Instead of taking a shot, for each question you decide to skip you will replay a past truth or a dare for double the time.'
                : 'Switch to Drink Mode? Instead of replaying, you\'ll take a shot for each question you decide to skip.'
            }
            showButtonOne={true}
            textButtonOne={gameMode === 'drink' ? 'Switch to Replay Mode' : 'Switch to Drink Mode'}
            onButtonOne={handleConfirmSwitchGameMode}
          />
          <AccessoryCardPopover
          open={accessoryPopoverOpen}
          onClose={() => setAccessoryPopoverOpen(false)}
          onAccessoryChange={handleAccessoryChange}
          gameType={gameType}
          />
          {/* <Login
          open = {loginPopoverOpen}
          onClose = {() => setLoginPopoverOpen(false)}
          /> */}
          </Box>
        </ThemedPopover>
      </>
    );
  };
  
  
  export default MenuButton;
  
  
  // Styled buttons inside the popover
  //   const PopoverButton = styled(Button)({
    //     backgroundColor: '#C2185B',
    //     color: 'white',
    //     fontWeight: 'bold',
//     width: '100%',
//     margin: '10px 0',
//     borderRadius: '15px',
//     textShadow: '0px 2px 4px rgba(0, 0, 0, 0.4)',
//     '&:hover': {
  //       backgroundColor: '#AD1457',
  //     },
  //   });
  
  // const PopoverCard = styled(Box)({
  //   padding: '20px',
  //   background: '#2e002e',
  //   borderRadius: '10px',
  //   boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.5)',
  //   color: 'white',
  //   minWidth: '200px',
  //   textAlign: 'center',
  // });
  
  // const OptionItem = styled(ListItem)({
  //   background: '#450045',
  //   margin: '5px 0',
  //   borderRadius: '5px',
  //   '&:hover': {
  //     backgroundColor: '#600060',
  //   },
  // });
    
  //   // Styled popover menu
  //   const PopoverCard = styled(Box)({
  //     background: 'radial-gradient(circle at top left, rgba(234, 61, 255, 0.4), rgba(0, 0, 0, 0) 40%), radial-gradient(circle at bottom right, rgba(234, 61, 255, 0.4), rgba(0, 0, 0, 0) 40%), #000000',
  //     padding: '20px',
  //     borderRadius: '15px',
  //     width: '200px',
  //     boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.5)',
  //     textAlign: 'center',
  //   });